// extracted by mini-css-extract-plugin
export default {"buttonCarousel":"Oncocollections_buttonCarousel__nY7RO","item":"Oncocollections_item__EqvCu","title":"Oncocollections_title__uPNEh"};